var gameConfig = {
    "public_root" : "/",
    //"https://myipc.io/",
    "Asset_Path" : "src/game/assets/",
    "IPC_Speed" : 400,
    "Tile_Size" : 250,
    "currentAddress": "",
    "addressEntries": {}
};

export default gameConfig;